import { render, staticRenderFns } from "./platformMerchant.vue?vue&type=template&id=60846d1a&scoped=true"
import script from "./platformMerchant.vue?vue&type=script&lang=js"
export * from "./platformMerchant.vue?vue&type=script&lang=js"
import style0 from "./platformMerchant.vue?vue&type=style&index=0&id=60846d1a&prod&scoped=true&lang=css"
import style1 from "./platformMerchant.vue?vue&type=style&index=1&id=60846d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60846d1a",
  null
  
)

export default component.exports